// src/components/Button.tsx

import React from 'react';
import { useDebounceFn } from 'ahooks';
import './index.scss';

interface ButtonProps {
  variant: 'important' | 'white' | 'black' | 'blueText' | 'blue' | 'redText' | 'gray'; // 定义可用的样式变体
  children: React.ReactNode; // 按钮内的内容
  onClick?: () => void; // 点击事件处理函数
  className?: string; // 额外的 CSS 类
  disabled?: boolean; // 按钮是否禁用
}

const Button: React.FC<ButtonProps> = ({
  variant,
  children,
  onClick,
  className = '',
  disabled = false, // 默认值为 false
  ...props
}) => {
  const { run: debouncedClick } = useDebounceFn(
    () => {
      if (onClick) {
        onClick();
      }
    },
    { wait: 300 }, // 防抖间隔时间，可根据需求调整
  );

  return (
    <button
      className={`button ${variant} ${className} ${disabled ? 'disabled' : ''}`}
      onClick={disabled ? undefined : debouncedClick} // 如果禁用，阻止点击事件
      disabled={disabled} // 禁用按钮
      {...props}
    >
      {children}
    </button>
  );
};

export { Button };
